goog.provide("shadow.js.shim.module$$mui$material$Toolbar");
goog.provide("module$shadow_js_shim_module$$mui$material$Toolbar");
shadow.js.shim.module$$mui$material$Toolbar = shadow.js.nativeProvides["@mui/material/Toolbar"] = shadow$bridge("@mui/material/Toolbar");
module$shadow_js_shim_module$$mui$material$Toolbar.default = shadow.js.shim.module$$mui$material$Toolbar;
